module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTCw8UCw8UCw8UCw6UC07UCw7UC08UCw7UC09UC08UEOvzFIAAAAKdFJOUwA+wp4Y5Xhgr1C5PjTbAAABCUlEQVQ4y+3UMWvCQBQH8KeJcU3aqJBJLF2chLjoFBHFVXR6k0gRmimdCp1ExL1+gvbCC+V9ygZFzUWfU6bS/xDu+JF3xyXvAP4DZuP9mM/gip75lDiPI37yj9nwNGe4PQ8nSqcSZcqjrZkVZyb9hWaG8i9pdzQrczbrO9bU7Tsz8Qo06xXqL5JRgAupJq6UuN4HziUrefwmWYWZxPceYkeyGtJMssf2T0/cp/cln9nALvisB67ppDHdG4bq8PGHJNuY5JrgFrhPq9VNB+NWlDcjgT5TkPYCxxDq/66l9uRgBwxq4BQjvTWR5zBKIEyfTLn+G+4CqLLPEZjL7q2eDzmR74OV/deuuF/kvmi5/7R+qQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wsii1.png
// module id = NPrn
// module chunks = 0